import React from "react";

export default ({ attachmentSrc, type, audioDisplay = false }) => {
  return (
    <audio controls className={!audioDisplay ? null : audioDisplay}>
      <source src={attachmentSrc} type={type} />
      Your browser does not support the audio element.
    </audio>
  );
};
